<template>
    <v-layout>
        <v-flex xs12>
            <v-card>
                <v-card-title class="headline primary white--text">
                    Anomaly Descriptions
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="accent" @click="editedItem=null;dialog=true" :disabled="!$can('update', 'AnomalyDescription')"><v-icon small class="mr-2">fa-plus</v-icon> Add Record</v-btn>
                    <anomaly-description-dialog v-model="dialog" :item="editedItem" v-on:doreload="refresh()"></anomaly-description-dialog>
                </v-card-actions>

                <v-card-text>
 <v-data-table
                    :headers="headers"
                    :items="anomalyDescription"
                    class="elevation-1"
            >
      <template v-slot:items="props">
        <td>{{ props.item.desc }}</td>
        <td>{{ props.item.severity }}</td>
        <td>{{ props.item.topic }}</td>
        <td class="justify-center layout px-0">
          <v-icon
            small
            class="mr-2"
            @click="$can('update', 'AnomalyDescription') && editItem(props.item)"
          >
            fa-edit
          </v-icon>
          <v-icon
            small
            @click="$can('update', 'AnomalyDescription') && deleteItem(props.item)"
          >
            fa-trash
          </v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import {getAnomalyDescription, deleteAnomalyDescription} from '../helper'
import AnomalyDescriptionDialog from "../components/AnomalyDescriptionDialog";

export default {
    name: 'AnomalyDescription',
  components: { AnomalyDescriptionDialog },
  data: () => ({
      dialog: false,
      headers: [
        { text: 'Description', value: 'desc' },
        { text: 'Severity', value: 'severity', sortable: false },
        { text: 'Topic', value: 'topic'},
        { text: 'Action ', sortable: false },
      ],
      anomalyDescription: [],
      editedIndex: -1,
      editedItem: {
      },
    }),
    
  mounted() {
    this.initialize()
  },
    methods: {
      initialize () {
        this.refresh()
      },

      editItem (item) {
        this.editedIndex = this.anomalyDescription.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      async deleteItem (item) {
        const index = this.anomalyDescription.indexOf(item)
        if (confirm('Are you sure you want to delete this item?') ){
          this.anomalyDescription.splice(index, 1)
          await deleteAnomalyDescription({
            'anomaly_description_id': item.anomaly_description_id
          })
          this.refresh()
        }
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        if (this.editedIndex > -1) {
          Object.assign(this.anomalyDescription[this.editedIndex], this.editedItem)
        } else {
          this.anomalyDescription.push(this.editedItem)
        }
        this.close()
      },
      async refresh() {
        let df = await getAnomalyDescription({
          facility_name: this.$store.state.pointsListStore.pointsList.facility_name
        })
        this.anomalyDescription = df['result']
      }
    }
  }
</script>

<style scoped>

</style>
